
export const ROLES = Object.freeze({
    SEEKER : 'Seeker',
    ORGANIZER : 'Organizer',
    ADMIN : 'Admin',
    PLANNER:'Event Planner'
})

export const WEBSITE =
    "https://cultureinyourcity.com/"
    //"https://renloc.vercel.app/"
    // "https://dev.renloc.com/"

export const PUBLIC_ENDPOINTS = ['/auth/signup','/auth/email-verification'
    ,'/auth/login','/auth/forgot-password','/auth/forgot-password/change-password'
    ,'/auth/user-validation']

/***
 * Media BaseUrl
 * @type {string}
 */
export const MEDIA_BASEURL = `${process.env.VUE_APP_API_URL}uploads/`


/***
 * Main Site BaseUrl
 * @type {string}
 */
export const MAIN_SITE_BASEURL = "https://cultureinyourcity.com/"

/***
 * Event images live in a private S3 bucket - the backend hands back a
 * ready-to-use, time-limited presigned URL for each uploaded image, not a
 * bare filename. The placeholder is the one exception: it's never uploaded
 * to S3, and this admin project has no local copy of it either, so it's
 * served from the public site's own public/ folder instead.
 * @type {string}
 */
export const AWS_URL = process.env.VUE_APP_AWS_URL || ''
export const EVENT_PLACEHOLDER_IMAGE = 'event-placeholder.png'

export const getEventImageUrl = (value) => {
    if (!value || value === EVENT_PLACEHOLDER_IMAGE) {
        return `${MAIN_SITE_BASEURL}${EVENT_PLACEHOLDER_IMAGE}`
    }
    // Already a full URL (presigned S3 URL from the backend) - use as-is.
    if (/^https?:\/\//i.test(value)) {
        return value
    }
    // Fallback for any bare filename that slips through unpresigned.
    return `${AWS_URL}/${value}`
}
